<template>
    <div
        class="input-group"
    >
        <input
            v-if="name"
            type="hidden"
            :name="name"
            :value="content"
        >
        <ckeditor
            v-if="loaded"
            ref="ck"
            v-model="content"
            :showalways="true"
            :params="editorConfig"
            :class="error ? 'form-control hauto is_invalid' : 'form-control hauto'"
            :singleline="true"
            :autofocus="false"
            @input="sanitizeEmoji"
        />
        <div
            class="input-group-append ckeditor-emoji"
        >
            <span
                :id="'ckeditor-container-'+_uid"
                style="padding: 0;"
                class="btn btn-secondary"
            />
        </div>
        <div
            v-if="error"
            class="invalid-feedback d-block"
        >
            {{ error }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EmojiPicker',
        props: {
            name: {
                type: String,
                default: '',
            },
            val: {
                type: String,
                default: '',
            },
            emojionly: {
                type: Boolean,
                default: false
            },
            emoji: {
                type: Array,
                default: function() { return []},
            },
            emojikey: {
                type: String,
                default: '',
            },
            invalid: {
                type: Boolean,
                default: false,
            },
            error: {
                type: String,
                default: null,
            }
        },
        data: function() {
            return {
                content: this.val || '', 
                loaded: false,
                editorConfig: {
                    bodyId: 'emoji-cke',
                    language: 'ru',
                    toolbar: [{ name: 'colors', items: ['EmojiList']}],
                    bodyClass: 'emoji-only-ckeditor',
                    extraPlugins: 'sharedspace,emojilist', 
                    removePlugins: 'elementspath,resize,emoji,link,sourcearea,balloonpanel,balloontoolbar',
                    fillEmptyBlocks: false,
                    basicEntities: false,
                    sharedSpaces: {top: 'ckeditor-container-'+this._uid},
                    allowedContent: '',
                    forcePasteAsPlainText: true,
                    enterMode : CKEDITOR.ENTER_BR,
                    shiftEnterMode: CKEDITOR.ENTER_BR,
                    extraPlugins: 'emojilist', 
                    resize_enabled: false,
                    tabSpaces: 0,
                    emoji: this.emoji,
                    emojiKey: this.emojikey, 
                }
            }
        },
        watch: {
            emoji: {
                handler: function(newVal, oldVal) {
                    if (newVal.length > 0) {
                        this.editorConfig.emoji = this.emoji;
                    }
                    this.loaded = true;
                },
            },
            content: {
                handler: function(newVal, oldVal) {
                    this.$emit('change', newVal);
                }
            }
        },
        mounted: function() {
            this.$emit('mounted');
        },
        methods: {
            sanitizeEmoji: function(val) {
                if (!this.emojionly) {
                    return
                }
                var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|[\ud83c[\ude50\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

                let matches = this.content.match(regex);
                if (matches) {
                    this.content = matches.join('');
                } else {
                    this.content = ''; 
                }
            },
        }
    }
</script>


